import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api`;

// Create axios instance with withCredentials
const axiosInstance = axios.create({
  withCredentials: true
});

const api = {
  // Skills
  getSkills: () => axiosInstance.get(`${API_URL}/skills`),
  createSkill: (data) => axiosInstance.post(`${API_URL}/skills`, data),
  updateSkill: (id, data) => axiosInstance.put(`${API_URL}/skills/${id}`, data),
  deleteSkill: (id) => axiosInstance.delete(`${API_URL}/skills/${id}`),

  // Levels
  getLevels: () => axiosInstance.get(`${API_URL}/levels`),
  createLevel: (data) => axiosInstance.post(`${API_URL}/levels`, data),
  updateLevel: (id, data) => axiosInstance.put(`${API_URL}/levels/${id}`, data),
  deleteLevel: (id) => axiosInstance.delete(`${API_URL}/levels/${id}`),
  updateLevelsOrder: (data) => axiosInstance.put(`${API_URL}/levels/order`, data),

  // Skill Groups
  getSkillGroups: () => axiosInstance.get(`${API_URL}/skill-groups`),
  createSkillGroup: (data) => axiosInstance.post(`${API_URL}/skill-groups`, data),
  updateSkillGroup: (id, data) => axiosInstance.put(`${API_URL}/skill-groups/${id}`, data),
  deleteSkillGroup: (id) => axiosInstance.delete(`${API_URL}/skill-groups/${id}`),
  updateSkillGroupsOrder: (data) => axiosInstance.put(`${API_URL}/skill-groups/order`, data),

  // Team Members
  getTeamMembers: () => axiosInstance.get(`${API_URL}/team-members`),
  createTeamMember: (data) => axiosInstance.post(`${API_URL}/team-members`, data),
  updateTeamMember: (id, data) => axiosInstance.put(`${API_URL}/team-members/${id}`, data),
  deleteTeamMember: (id) => axiosInstance.delete(`${API_URL}/team-members/${id}`),
  assignSkillToMember: (memberId, data) => axiosInstance.post(`${API_URL}/team-members/${memberId}/skills`, data),
  removeSkillFromMember: (memberId, skillId) => axiosInstance.delete(`${API_URL}/team-members/${memberId}/skills/${skillId}`),
  updateMemberSkillStatus: (memberId, skillId, status) => 
    axiosInstance.put(`${API_URL}/team-members/${memberId}/skills/${skillId}/status`, { status }),

  // Skill Level Descriptions
  getSkillLevelDescriptions: () => axiosInstance.get(`${API_URL}/skill-level-descriptions`),
  createSkillLevelDescription: (data) => axiosInstance.post(`${API_URL}/skill-level-descriptions`, data),
  updateSkillLevelDescription: (id, data) => axiosInstance.put(`${API_URL}/skill-level-descriptions/${id}`, data),
  deleteSkillLevelDescription: (id) => axiosInstance.delete(`${API_URL}/skill-level-descriptions/${id}`),
  
  // Users
  getUsers: () => axiosInstance.get(`${API_URL}/users`),
  updateUserRole: (id, role) => axiosInstance.put(`${API_URL}/users/${id}/role`, { role }),
  
  // Departments
  getDepartments: () => axiosInstance.get(`${API_URL}/departments`),
  createDepartment: (data) => axiosInstance.post(`${API_URL}/departments`, data),
  updateDepartment: (id, data) => axiosInstance.put(`${API_URL}/departments/${id}`, data),
  deleteDepartment: (id) => axiosInstance.delete(`${API_URL}/departments/${id}`),
  
  // Mentor Assignments
  getMentorAssignments: () => axiosInstance.get(`${API_URL}/mentor-assignments`),
  saveMentorAssignment: (data) => axiosInstance.post(`${API_URL}/mentor-assignments`, data),
  deleteMentorAssignment: (focusMemberId, skillId) => axiosInstance.delete(`${API_URL}/mentor-assignments/${focusMemberId}/${skillId}`),
};

export default api; 